<template>
  <div>
    <v-img
      contain
      :src="pattern"
      style="position:absolute; bottom: 18vh; z-index:0"
    />
    <v-content class="pa-6 pa-md-12 white" style="z-index:200" fluid>
      <v-row justify="center" align="center">
        <v-col style="max-width: 800px;">
          <router-view /> <Footer class="mt-12" />
        </v-col>
        <v-col
          v-if="!$store.state.isMobile && $store.state.parentAuth.pageCount < 3"
          cols="7"
        >
          <v-img
            max-height="100%"
            class="mt-4"
            src="https://kajabi-storefronts-production.global.ssl.fastly.net/kajabi-storefronts-production/themes/2576244/settings_images/XsS2aIi4QUieJOUzJMma_Kids_Studying_from_Home-pana_3.jpg"
          />
        </v-col>
      </v-row>
    </v-content>
  </div>
</template>

<script>
  import Footer from "./core/Footer";
  import authToken from "../../../common/authToken";
  import { ROUTER_URL } from "../../../constants/parents/urls";

  export default {
    name: "AuthLayout",
    components: {
      Footer,
    },
    computed: {},
    data() {
      return {
        pattern: require("@/assets/bg-pattern.png"),
      };
    },
    created() {
      if (
        authToken.isCorrectAccessToken() &&
        !(this.$store.state.parentAuth.resourceId > 0)
      ) {
        this.$router.push({ name: ROUTER_URL.dashboard.children.home.name });
      }
      console.log(this.$route.query);
      if (this.$store.state.userUTM.utm_source == "Direct")
        this.$store.state.userUTM.utm_source = this.$route.query.utm_source
          ? this.$route.query.utm_source
          : "Direct";
      if (this.$store.state.userUTM.utm_medium == "None")
        this.$store.state.userUTM.utm_medium = this.$route.query.utm_medium
          ? this.$route.query.utm_medium
          : "None";
      if (this.$store.state.userUTM.utm_campaign == "None")
        this.$store.state.userUTM.utm_campaign = this.$route.query.utm_campaign
          ? this.$route.query.utm_campaign
          : "None";
    },
  };
</script>

<style>
  .auth-page-heading {
    color: #1d1d1d;
    font-size: 2.23rem;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 35px;
  }
  .auth-page-sub-heading {
    color: #2d2d2d;
    font-size: 1.5rem;
    font-weight: medium;
    letter-spacing: 0;
    line-height: 28px;
  }
  .v-stepper__header,
  .v-stepper {
    box-shadow: none !important;
    background: none !important;
  }

  .v-stepper__step__step {
    background-color: white !important;
    border: 2px solid #5271ff;
    color: #5271ff !important;
    font-weight: 600;
    font-size: 1rem;
    line-height: 8px;
  }

  .v-stepper__step {
    align-items: center !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 28px !important;
    position: relative !important;
  }

  .v-stepper__label {
    font-size: 12px !important;
    width: 62px !important;
    text-align: center !important;
    display: block !important;
    color: #1d1d1d !important;
    font-weight: bold !important;
    margin-top: 4px !important;
    position: absolute !important;
    top: -8px !important;
  }

  .v-stepper__step--complete > .v-stepper__step__step {
    background-color: #5271ff !important;
  }
</style>
